module.exports = __webpack_public_path__ + "assets/7fb781188cbcf8c09e84944575ef50a5.svg";